import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { HERO_VIDEO_URL } from "constants/common.constants";

const DemoPage = () => {
  return (
    <Box
      sx={{
        py: 10,
        px: 2,
        backgroundColor: "#F9FAFB",
        minHeight: { xs: "calc(100svh - 128px)", md: "100%" },
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <Typography variant="h3" fontWeight="bold" mb={3} color="#1A1A1A">
          See Genie in Action
        </Typography>
        <Typography variant="h6" color="text.secondary" mb={5}>
          Watch how Genie transforms raw data into actionable insights, complete with visualizations, full
          reports, and automatic phrasing.
        </Typography>

        <Box
          component="video"
          controls
          sx={{
            width: "100%",
            maxHeight: 500,
            borderRadius: 4,
            boxShadow: 4,
          }}
        >
          <source src={HERO_VIDEO_URL} type="video/mp4" />
          Your browser does not support the video tag.
        </Box>
      </Container>
    </Box>
  );
};

export default DemoPage;
